export enum PageComponentTypeEnum {
	CAROUSEL = 'carousel',
	HIGHLIGHTED_BLOCK = 'highlighted_block',
	IMAGE_BOX = 'image_box',
	ABOUT_US = 'abouts_us',
	FAQS = 'faqs',
	PARTNERS = 'partners',
	NEWS = 'news',
	FORMS = 'forms',
	SIMPLE_TEXT = 'simple_text',
	VIDEO = 'video',
	MAP = 'map',
	TABLE = 'table',
	DIVIDER = 'divider',
	HIGHLIGHTED_TITLE = 'highlighted_title',
	FORMATED_TEXT = 'formated_text',
	IMAGE_MONTAGE = 'image_montage',
	BLOG_POSTS = 'blog_posts',
	ADVANCED_IMAGE_BOX = 'advanced_image_box',
	IMAGE_AND_TEXT_BLOCK = 'image_and_text_block',
	DROPDOWN_BLOCK = 'dropdown_block',
	NOW_IN_THEATERS = 'now_in_theaters',
	COMING_SOON_TO_THEATERS = 'coming_soon_to_theaters',
	OUR_PREVIOUS_FILMS = 'our_previous_films',
	SOCIAL_MEDIA = 'social_media',
}
